import { Artikel } from './artikel';
import { Einheit } from './einheit';
import { StockAmount } from './stock-amount';

export interface ArtikelMenge extends StockAmount {
  artikel: Artikel;
  arteheingabe?: boolean;
  arteheingabePflicht?: boolean;
  idarteheingabe?: number;
  paletteartId?: number;
}
